import logo from "../../images/vivocolourportal_logo_2026.png";
import React, {memo} from "react";
import styles from './MainHeader.module.scss'
import LanguageSelector from "@components/page_components/common/LanguageSelector";
import CurrentUserComponent from "@components/page_components/common/CurrentUserComponent";
import DivisionSelector from "@components/page_components/common/DivisionSelector";
import LabSelector from "@components/page_components/common/LabSelector";
import Authorized from "@utils/auth/Authorized";
import {VivoPortal} from "@utils/AppConstants";
import {CommentNotificationIcon} from "@components/page_components/common/comments/CommentNotificationIcon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons"
import {CommonUtils} from "@utils/CommonUtils";

export default function MainHeader() {
    const {handlers} = useMainHeader()
    return (
        <header className={styles.header}>
            <div className={styles.logoContainer}>
                <FontAwesomeIcon onClick={x=>handlers.handleToggleSidebarVisibility()} className={styles.mobileNavIcon} icon={icons.faBars}/>
                <a className={"gap-3"} href="/">
                    <img className={styles.logo} src={logo} alt="Vivo ColourPortal logo"/>
                </a>
            </div>
            <div className={styles.headerRight}>
                <Authorized roleMask={VivoPortal.EnumMemberGroupAliases.User}>
                    <>
                        <LabSelector/>
                        <DivisionSelector/>
                    </>
                </Authorized>
                <LanguageSelector/>
                <CommentNotificationIcon/>
                <CurrentUserComponent/>
            </div>
        </header>
    )
}

function useMainHeader(){
    return{
        handlers:{
            handleToggleSidebarVisibility : CommonUtils.handleToggleSidebarVisibility
        }
    }
}